// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const fasCopyright: CreateIconOptions = {
  "displayName": "FASCopyright",
  "viewBox": "0, 0, 512, 512",
  "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM199.4 312.6c31.2 31.2 81.9 31.2 113.1 0c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-50 50-131 50-181 0s-50-131 0-181s131-50 181 0c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-31.2-31.2-81.9-31.2-113.1 0s-31.2 81.9 0 113.1z"
};
